import { GlossaryData } from "@/types";
import { backendApi } from "./api.service";
import { useMutation, useQuery } from "@tanstack/react-query";

type PaginationRequest = {
  page?: number;
  pageSize?: number;
  name?: string;
};

export const useCreateGlossary = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (data: GlossaryData) =>
      backendApi.post("/glossaries/add-glossary", data, config),
  });
};

export const useGetAllGlossariesByContent = (pagination: PaginationRequest) => {
  const config = { withCredentials: true, params: pagination };
  return useQuery({
    queryKey: ["get-glossaries-by-content", pagination],
    queryFn: () => backendApi.get("/glossaries/get-all", config),
  });
};

export const useEditGlossary = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<GlossaryData> }) =>
      backendApi.put(`/glossaries/update/${id}`, data, config),
  });
};

export const useDeleteGlossary = () => {
  const config = { withCredentials: true };
  return useMutation({
    mutationFn: (glossaryId: string) =>
      backendApi.delete(`/glossaries/delete/${glossaryId}`, config),
  });
};

export const useGetAllGlossariesByLetter = (pagination: PaginationRequest) => {
  const config = { withCredentials: true, params: pagination };
  return useQuery({
    queryKey: ["get-glossaries-by-letter", pagination],
    queryFn: () => backendApi.get("/glossaries/get-by-letter", config),
  });
};
